import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ButtonBase, Collapse, Divider, List, ListSubheader } from "@mui/material";
import React, { useId } from "react";
import { usePersistedSetting } from "../../common/hooks/usePersistedSetting";

export default function MenuSection({ appId, title, open, children }: {
  appId?: string;
  title?: string;
  open: boolean;
  children: React.ReactNode;
}) {
  const [expanded, setExpanded] = usePersistedSetting<boolean>(
    `leftMenu.sectionExpanded:${appId ?? "default"}:${title ?? "Main"}`, false,
  );
  const contentId = useId();

  return <>
    {!open && <Divider />}
    <List component="div" dense subheader={open && title ? (
      <ListSubheader component="div" disableSticky sx={{ backgroundColor: "inherit", p: 0 }}>
        <ButtonBase onClick={() => setExpanded(value => !value)} aria-expanded={expanded} aria-controls={contentId}
          sx={{ width: "100%", display: "flex", justifyContent: "space-between", px: 2, minHeight: 32,
            color: "text.secondary", fontSize: "0.7rem", fontWeight: 600, textTransform: "uppercase",
            letterSpacing: "0.5px", textAlign: "left", "&.Mui-focusVisible": { outline: "2px solid", outlineColor: "primary.main", outlineOffset: -2 } }}>
          {title}
          {expanded ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
        </ButtonBase>
      </ListSubheader>
    ) : undefined}>
      <Collapse in={!open || !title || expanded} timeout="auto" unmountOnExit>
        <List id={contentId} dense disablePadding>{children}</List>
      </Collapse>
    </List>
  </>;
}
